import { isValidLatin } from '../middleware/validation/rules';

export const hasUnicode = (contactObj) => {
    const values = Object.values(contactObj);
    for (let i = 0; i < values.length; i += 1) {
        const element = values[i];
        if (typeof element === 'string' || element instanceof String) {
            if (!isValidLatin.validate(element)) {
                return true;
            }
        }
    }
    return false;
};

export const includePropertyName = (locale) => {
    const isShowingLatinPropertyNameLocales = ['ko_KR', 'zh_CN', 'ja_JP', 'zh_TW', 'zh_HK'];
    return isShowingLatinPropertyNameLocales.includes(locale);
};

export default {
    hasUnicode
};
